import './toolbar.sass'

import React from 'react';

import TrackViewOptionsSwitch from 'controls/track-view-options-switch/TrackViewOptionsSwitch';
import TrackRangeSlider from 'controls/track-range-slider/TrackRangeSlider';
import ShowChartButton from 'components/track-params/show-chart-button/ShowChartButton';

import NavbarToggle from 'controls/navbar-toggle/NavbarToggle';

export default class Toolbar extends React.Component {
  render() {
    return (
      <nav className='track-params-toolbar navbar navbar-default'>
        <div className='container-fluid'>
          <div className='navbar-header'>
            <NavbarToggle/>
          </div>

          <div className='collapse navbar-collapse' id='bs-navbar-collapse'>
            <TrackViewOptionsSwitch
              view={ 'params' }
              trackId={ this.props.trackId }
            />
            <TrackRangeSlider
              trackId={ this.props.trackId }
            />
            <ShowChartButton
              trackId={ this.props.trackId }
            />
          </div>
        </div>
      </nav>
    );
  }
}
